import './style.css'
import './loading.js'
import { noise } from './perlin.js'
import * as THREE from 'three'
import * as dat from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { GLBufferAttribute, Vector3 } from 'three'
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js'


// Debug
// const gui = new dat.GUI()


// Canvas
const canvas = document.getElementById('webgl')

// Scene
const scene = new THREE.Scene()

/** Sizes */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/** Camera */
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1000)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 80
// camera.lookAt(scene.position);
scene.add(camera)


const trackballsControls = new TrackballControls(camera, canvas)
trackballsControls.panSpeed = 0.3
trackballsControls.rotateSpeed = 1.0
trackballsControls.maxDistance = 100
// trackballsControls.staticMoving = true
trackballsControls.noZoom = true


/** Renderer */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.shadowMap.enabled = true;
renderer.setClearColor("rgba(221, 221, 221, 0.61)", 1);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


// Light
const directionalLight = new THREE.DirectionalLight(0xffffff, 1.0);
directionalLight.position.set(10, 2, 50);
scene.add(directionalLight);

// const helper = new THREE.DirectionalLightHelper( directionalLight, 1 ); 
// scene.add( helper );


/** container for text and cube */
const container = new THREE.Object3D()
scene.add(container)


/** Create 3D text */
let textMesh;
const fontSize = 3;
function createTextGeometry(text, font, deg) {
    const textGeometry = new TextGeometry(text, {
        font: font,
        size: fontSize,
        height: 0.8,
        curveSegments: 5
    })
    textGeometry.center()

    const material = new THREE.MeshPhongMaterial({ color: 0xffff00 }) // "rotated text" font color

    //点の球面座標 Spherical(球体)
    const radius = 17; // 半径、または点から原点までの直線距離
    const phi = 90 * (Math.PI / 180) //phi(経度) y(上)軸からのラジアン単位の極角
    const theta = deg * (Math.PI / 180) //theta(緯度) convert radian to degree y(↑)軸を中心としたラジアン単位の赤道角
    const sphericalPosition = new THREE.Spherical(radius, phi, theta)

    textMesh = new THREE.Mesh(textGeometry, material)
    textMesh.position.setFromSpherical(sphericalPosition)
    
    const vector = new THREE.Vector3()
    vector.copy(textMesh.position).multiplyScalar(2)

    textMesh.lookAt(vector)
    container.add(textMesh)
}


/** Textures */
const textureLoader = new THREE.TextureLoader()
const texture = textureLoader.load('/textures/matcaps/3.png')
const matcapDonutTexture = textureLoader.load('/textures/matcaps/2.png')


/** Fonts */
const fontLoader = new FontLoader()
fontLoader.load(
    '/fonts/helvetiker_regular.typeface.json',
    (font) => {
        createTextGeometry("N", font, 0)
        createTextGeometry("E", font, 15)
        createTextGeometry("W", font, 30)
        createTextGeometry(" ", font, 45)
        createTextGeometry("O", font, 60)
        createTextGeometry("P", font, 75)
        createTextGeometry("E", font, 90)
        createTextGeometry("N", font, 105)


        // /** donuts */
        // const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 40)
        const donutGeometry = new THREE.CircleGeometry( 0.8, 0.8 )
        const donutMaterial = new THREE.MeshMatcapMaterial({ 
            matcap: matcapDonutTexture,
         })
        for (let i = 0; i < 3000; i++) {
            const donut = new THREE.Mesh(donutGeometry, donutMaterial)

            donut.position.x = (Math.random() - 0.5) * 75
            donut.position.y = (Math.random() - 0.5) * 35
            donut.position.z = (Math.random() - 0.5) * 35

            donut.rotation.x = Math.random() * Math.PI
            donut.rotation.y = Math.random() * Math.PI

            // we need to use the same value for all 3 axes (x, y, z)
            const scale = Math.random()
            donut.scale.set(scale, scale, scale)

            scene.add(donut)
        }
    })

/** Object */
const sphereGeometry = new THREE.SphereGeometry(15, 20, 40);
const sphereMaterial = new THREE.MeshMatcapMaterial({
    matcap: texture,
});
const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
// console.log(sphere.geometry.attributes.position.array);
// sphere.rotation.x = - Math.PI * 0.15
container.add(sphere);


// noise sphere uv 
function moveSphereVertex() {
    
    const positions = sphere.geometry.attributes.position.array;
    const time = performance.now() / 1000;
    const x = 10;
    const y = 4;
    const z = 1;
    // console.log(positions.length); // 2583

    for (let i = 0; i < positions.length; i += 10) {
        const position = new THREE.Vector3(
            positions[i],
            positions[i + 1],
            positions[i]
        );

        position.normalize().multiplyScalar(
            x + 10.0 * noise.perlin3(position.x * y + time, position.y * y, position.z * z)
        );

        positions[i] = position.x
        positions[i + 1] = position.y
        positions[i] = position.z
    }

    // 頂点情報の更新
    sphere.geometry.attributes.position.needsUpdate = true;

    // 法線情報の更新
    sphere.geometry.computeVertexNormals();
}

// Debug
// const contorlPanel = {
//     color: 0xffffff,
// };
// gui.addColor(contorlPanel, 'color').onChange(() => {
//     sphereMaterial.color.set(contorlPanel.color)
// });


window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})


const clock = new THREE.Clock()

const loop = () => {
    const elapsedTime = clock.getElapsedTime()
    container.rotation.y = - elapsedTime * 0.3
    container.rotation.z = Math.PI * 0.07

    trackballsControls.update(elapsedTime)
    
    moveSphereVertex()

    // Render
    renderer.render(scene, camera)

    // Call loop again on the next frame
    window.requestAnimationFrame(loop)
}

loop()
